'use client';
import Link from 'next/link';

const YourGatewaySection = ({ heading, paragraph, growthData, highlight }) => (
  <div className="w-full flex flex-col justify-center items-center bg-[#172554] lg:py-20 lg:px-20 py-10 px-10 max-w-[1750px] mx-auto">
    <div className="flex flex-col justify-center items-center">
      <h2 className="font-inter font-bold lg:text-4xl text-2xl text-white mb-7 text-center">
        {heading}
        <span className="text-[#046DEB]">{highlight}</span>
      </h2>

      <p className="font-inter lg:text-lg text-base font-normal text-[#ffff]/90 text-center max-w-[1280px] mb-10">
        {paragraph}
      </p>

      <div className="w-full max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-20 justify-items-center">
        {growthData.map((item, index) => (
          <div
            key={index}
            className=" w-full max-w-sm  flex flex-col lg:p-4 hover:bg-[#21367c] lg:gap-y-2 gap-y-0 hover:gap-y-0 transition-all duration-150"
          >
            <div className="bg-[#344681] lg:w-[40px] lg:h-[40px] w-[28px] h-[28px] rounded-full"></div>

            <h4 className="font-inter font-bold text-xl text-white py-4">
              {item.title}
            </h4>

            <p className="text-[#E3E3E3] font-inter font-medium text-base leading-relaxed">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default YourGatewaySection;

// w-full max-w-sm xl:h-[310px] lg:h-[380px] flex flex-col lg:p-4 hover:bg-[#21367c] lg:gap-y-2 gap-y-0 hover:gap-y-0 transition-all duration-150